// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
    display: flex;
    justify-content: space-between;
    padding: 15px;
    align-items: center;
    margin: 7px 8px;
    overflow: visible;
    position: relative;
    z-index: 4;
}

.header-info {
    min-width: 0;
    flex: 1 1;
    padding-right: 8px;
    color: var(--Black, #202226);
    font-size: 17px;
    font-style: normal;
    font-weight: 600;

    >h3 {
        color: var(--Black, #202226);
        font-size: 15px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;

        span {
            color: var(--brand-primary, #0877BC);
            font-weight: 700;
            text-transform: capitalize;
        }
    }

    >p {
        color: var(--brand-text-secondary, #838383);
        font-family: var(--brand-font);
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
    }
}

.header-trailing {
    display: flex;
    align-items: center;
    gap: 7px;
    flex-shrink: 0;
    position: relative;
    z-index: 2;
}

/* Role switcher (left) + club logo (right), always one row. */
.header-brand-stack {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 7px;
    position: relative;
    z-index: 2;
}

/* Top-right club / default logo — same row height as .notification-btn (40px), show full mark */
.clublogo {
    width: 56px;
    height: 56px;
    max-width: 56px;
    max-height: 56px;
    padding: 4px;
    box-sizing: border-box;
    object-fit: contain;
    object-position: center;
    border-radius: 12px; /* Sleek modern squircle */
    border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08);
    background-color: var(--brand-surface, #fff);
    flex-shrink: 0;
    display: block;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.clublogo:hover {
    transform: translateY(-2px);
    border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.2);
    box-shadow: 0 6px 16px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08), 0 2px 4px rgba(0, 0, 0, 0.02);
}

.header-role-badge {
    position: relative;
    flex-shrink: 0;
    z-index: 3;
}

/* Profile page: same control as home, parked in the empty header leading slot. */
.header-role-badge--profile {
    margin: 0;
}

.user-profile-header .header-trailing,
.user-profile-header .header-brand-stack {
    flex-direction: row !important;
    align-items: center !important;
}

@media (max-width: 768px) {
    .user-profile-header {
        align-items: center !important;
    }
}

.header-role-btn {
    width: 56px;
    height: 56px;
    max-width: 56px;
    max-height: 56px;
    padding: 0;
    box-sizing: border-box;
    border-radius: 12px;
    border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);
    background: var(--brand-surface, #fff);
    color: var(--brand-primary, #0877BC);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    cursor: default;
}

.header-role-btn.is-switchable {
    cursor: pointer;
}

.header-role-btn.is-switchable:hover,
.header-role-btn.is-open {
    transform: translateY(-2px);
    border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);
    box-shadow: 0 6px 16px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12), 0 2px 4px rgba(0, 0, 0, 0.04);
}

.header-role-btn:disabled {
    opacity: 1;
    cursor: default;
}

.header-role-btn--coach,
.header-role-btn--monitor {
    color: #0f766e;
    padding: 3px;
    overflow: hidden;
}

/* Full avatar in the 56px control; clip PNG's square canvas to a circle. */
.header-role-btn--coach .coach-role-icon,
.header-role-btn--monitor .coach-role-icon {
    width: 100% !important;
    height: 100% !important;
    border-radius: 50%;
    object-fit: cover;
}

.header-role-btn--player {
    color: var(--brand-primary, #0877BC);
    padding: 3px;
    overflow: hidden;
}

.header-role-btn--player .player-role-icon {
    width: 100% !important;
    height: 100% !important;
    border-radius: 50%;
    object-fit: cover;
    background: #f3f4f6;
}

.header-role-menu__icon .player-role-icon {
    width: 22px !important;
    height: 22px !important;
}

.header-role-btn--admin,
.header-role-btn--committee,
.header-role-btn--moderator {
    color: #1d4ed8;
}

.header-role-btn--parent {
    color: #a16207;
}

.header-role-menu {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    z-index: 50;
    min-width: 200px;
    padding: 8px;
    border-radius: 14px;
    border: 1px solid var(--border-color, rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12));
    background: var(--surface-color, #fff);
    color: var(--text-color, #202226);
    box-shadow: 0 12px 28px var(--shadow-color, rgba(15, 23, 42, 0.14));
}

/* Portaled above club switcher / home cards — must beat page stacking. */
.header-role-menu--portal {
    position: fixed;
    top: auto;
    right: auto;
    z-index: 12050;
}

.header-role-menu__legend {
    margin: 0 0 6px;
    padding: 4px 8px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: var(--text-secondary, var(--brand-text-secondary, #838383));
}

.header-role-menu__item {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 10px;
    border: none;
    border-radius: 10px;
    background: transparent;
    color: var(--text-color, #202226);
    font: inherit;
    font-size: 14px;
    font-weight: 600;
    text-align: left;
    cursor: pointer;
}

.header-role-menu__item:hover {
    background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08);
}

.header-role-menu__item.is-selected {
    background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.14);
    color: var(--brand-primary, #0877BC);
}

.dark-mode .header-role-menu__item.is-selected {
    color: var(--brand-primary-light, #7dd3fc);
}

.header-role-menu__icon {
    width: 28px;
    height: 28px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: inherit;
}

@media (max-width: 768px) {
    .header {
        align-items: flex-start;
    }

    /* Notifications can stack above the brand icons; keep role + club on one row. */
    .header-trailing {
        flex-direction: column;
        align-items: flex-end;
        gap: 8px;
    }

    .header-brand-stack {
        flex-direction: row;
        align-items: center;
        gap: 7px;
    }
}

@media (max-width: 400px) {
    .clublogo,
    .header-role-btn {
        width: 48px;
        height: 48px;
        max-width: 48px;
        max-height: 48px;
    }
}

/* Modern squircle button with glassmorphism and springy animations */
.notification-btn {
    background: rgba(255, 255, 255, 0.72);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border-radius: 12px; /* Cohesive squircle */
    width: 40px;
    height: 40px;
    border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08);
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03);
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    position: relative;
    padding: 0;
    box-sizing: border-box;
    text-decoration: none;
}

.notification-btn img {
    width: 22px;
    height: 22px;
    object-fit: contain;
    transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.notification-btn:hover {
    background: var(--brand-surface, #fff);
    transform: translateY(-2px);
    border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.25);
    box-shadow: 0 6px 16px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12), 0 2px 4px rgba(0, 0, 0, 0.04);
}

.notification-btn:hover img {
    transform: scale(1.1);
}

.notification-btn:active {
    transform: translateY(0) scale(0.95);
    transition: all 0.1s ease;
}

/* Glowing Pulsating iOS-style red notification badge */
.notification-badge {
    position: absolute;
    top: 7px;
    right: 7px;
    width: 8px;
    height: 8px;
    background-color: #ff3b30;
    border-radius: 50%;
    border: 2px solid var(--brand-surface, #fff);
    box-shadow: 0 0 8px rgba(255, 59, 48, 0.6);
    animation: badge-pulse 2s infinite;
}

@keyframes badge-pulse {
    0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(255, 59, 48, 0.7);
    }
    50% {
        transform: scale(1.05);
        box-shadow: 0 0 0 6px rgba(255, 59, 48, 0);
    }
    100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(255, 59, 48, 0);
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,SAAO;IACP,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;;IAEhB;QACI,4BAA4B;QAC5B,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;;QAEjB;YACI,oCAAoC;YACpC,gBAAgB;YAChB,0BAA0B;QAC9B;IACJ;;IAEA;QACI,2CAA2C;QAC3C,8BAA8B;QAC9B,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;IACrB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,kBAAkB;IAClB,UAAU;AACd;;AAEA,8DAA8D;AAC9D;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,UAAU;AACd;;AAEA,gGAAgG;AAChG;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB,EAAE,0BAA0B;IAC/C,mEAAmE;IACnE,4CAA4C;IAC5C,cAAc;IACd,cAAc;IACd,0CAA0C;IAC1C,iDAAiD;AACrD;;AAEA;IACI,2BAA2B;IAC3B,8DAA8D;IAC9D,uGAAuG;AAC3G;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,UAAU;AACd;;AAEA,iFAAiF;AACjF;IACI,SAAS;AACb;;AAEA;;IAEI,8BAA8B;IAC9B,8BAA8B;AAClC;;AAEA;IACI;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,sBAAsB;IACtB,mBAAmB;IACnB,mEAAmE;IACnE,sCAAsC;IACtC,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;IAC1C,iDAAiD;IACjD,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,2BAA2B;IAC3B,+DAA+D;IAC/D,uGAAuG;AAC3G;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;;IAEI,cAAc;IACd,YAAY;IACZ,gBAAgB;AACpB;;AAEA,2EAA2E;AAC3E;;IAEI,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,wFAAwF;IACxF,sCAAsC;IACtC,iCAAiC;IACjC,mEAAmE;AACvE;;AAEA,yEAAyE;AACzE;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,kEAAkE;AACtE;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,iCAAiC;IACjC,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,6DAA6D;IAC7D,oCAAoC;AACxC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA,gFAAgF;IAChF;QACI,sBAAsB;QACtB,qBAAqB;QACrB,QAAQ;IACZ;;IAEA;QACI,mBAAmB;QACnB,mBAAmB;QACnB,QAAQ;IACZ;AACJ;;AAEA;IACI;;QAEI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA,qEAAqE;AACrE;IACI,qCAAqC;IACrC,0BAA0B;IAC1B,kCAAkC;IAClC,mBAAmB,EAAE,sBAAsB;IAC3C,WAAW;IACX,YAAY;IACZ,mEAAmE;IACnE,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,0CAA0C;IAC1C,sDAAsD;IACtD,kBAAkB;IAClB,UAAU;IACV,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,4DAA4D;AAChE;;AAEA;IACI,sCAAsC;IACtC,2BAA2B;IAC3B,+DAA+D;IAC/D,uGAAuG;AAC3G;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA,uDAAuD;AACvD;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,4CAA4C;IAC5C,0CAA0C;IAC1C,kCAAkC;AACtC;;AAEA;IACI;QACI,sBAAsB;QACtB,0CAA0C;IAC9C;IACA;QACI,sBAAsB;QACtB,0CAA0C;IAC9C;IACA;QACI,sBAAsB;QACtB,wCAAwC;IAC5C;AACJ","sourcesContent":[".header {\n    display: flex;\n    justify-content: space-between;\n    padding: 15px;\n    align-items: center;\n    margin: 7px 8px;\n    overflow: visible;\n    position: relative;\n    z-index: 4;\n}\n\n.header-info {\n    min-width: 0;\n    flex: 1;\n    padding-right: 8px;\n    color: var(--Black, #202226);\n    font-size: 17px;\n    font-style: normal;\n    font-weight: 600;\n\n    >h3 {\n        color: var(--Black, #202226);\n        font-size: 15px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 24px;\n\n        span {\n            color: var(--brand-primary, #0877BC);\n            font-weight: 700;\n            text-transform: capitalize;\n        }\n    }\n\n    >p {\n        color: var(--brand-text-secondary, #838383);\n        font-family: var(--brand-font);\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 18px;\n    }\n}\n\n.header-trailing {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n    flex-shrink: 0;\n    position: relative;\n    z-index: 2;\n}\n\n/* Role switcher (left) + club logo (right), always one row. */\n.header-brand-stack {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 7px;\n    position: relative;\n    z-index: 2;\n}\n\n/* Top-right club / default logo — same row height as .notification-btn (40px), show full mark */\n.clublogo {\n    width: 56px;\n    height: 56px;\n    max-width: 56px;\n    max-height: 56px;\n    padding: 4px;\n    box-sizing: border-box;\n    object-fit: contain;\n    object-position: center;\n    border-radius: 12px; /* Sleek modern squircle */\n    border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08);\n    background-color: var(--brand-surface, #fff);\n    flex-shrink: 0;\n    display: block;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03);\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.clublogo:hover {\n    transform: translateY(-2px);\n    border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.2);\n    box-shadow: 0 6px 16px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08), 0 2px 4px rgba(0, 0, 0, 0.02);\n}\n\n.header-role-badge {\n    position: relative;\n    flex-shrink: 0;\n    z-index: 3;\n}\n\n/* Profile page: same control as home, parked in the empty header leading slot. */\n.header-role-badge--profile {\n    margin: 0;\n}\n\n.user-profile-header .header-trailing,\n.user-profile-header .header-brand-stack {\n    flex-direction: row !important;\n    align-items: center !important;\n}\n\n@media (max-width: 768px) {\n    .user-profile-header {\n        align-items: center !important;\n    }\n}\n\n.header-role-btn {\n    width: 56px;\n    height: 56px;\n    max-width: 56px;\n    max-height: 56px;\n    padding: 0;\n    box-sizing: border-box;\n    border-radius: 12px;\n    border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);\n    background: var(--brand-surface, #fff);\n    color: var(--brand-primary, #0877BC);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03);\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    cursor: default;\n}\n\n.header-role-btn.is-switchable {\n    cursor: pointer;\n}\n\n.header-role-btn.is-switchable:hover,\n.header-role-btn.is-open {\n    transform: translateY(-2px);\n    border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);\n    box-shadow: 0 6px 16px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12), 0 2px 4px rgba(0, 0, 0, 0.04);\n}\n\n.header-role-btn:disabled {\n    opacity: 1;\n    cursor: default;\n}\n\n.header-role-btn--coach,\n.header-role-btn--monitor {\n    color: #0f766e;\n    padding: 3px;\n    overflow: hidden;\n}\n\n/* Full avatar in the 56px control; clip PNG's square canvas to a circle. */\n.header-role-btn--coach .coach-role-icon,\n.header-role-btn--monitor .coach-role-icon {\n    width: 100% !important;\n    height: 100% !important;\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n.header-role-btn--player {\n    color: var(--brand-primary, #0877BC);\n    padding: 3px;\n    overflow: hidden;\n}\n\n.header-role-btn--player .player-role-icon {\n    width: 100% !important;\n    height: 100% !important;\n    border-radius: 50%;\n    object-fit: cover;\n    background: #f3f4f6;\n}\n\n.header-role-menu__icon .player-role-icon {\n    width: 22px !important;\n    height: 22px !important;\n}\n\n.header-role-btn--admin,\n.header-role-btn--committee,\n.header-role-btn--moderator {\n    color: #1d4ed8;\n}\n\n.header-role-btn--parent {\n    color: #a16207;\n}\n\n.header-role-menu {\n    position: absolute;\n    top: calc(100% + 8px);\n    right: 0;\n    z-index: 50;\n    min-width: 200px;\n    padding: 8px;\n    border-radius: 14px;\n    border: 1px solid var(--border-color, rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12));\n    background: var(--surface-color, #fff);\n    color: var(--text-color, #202226);\n    box-shadow: 0 12px 28px var(--shadow-color, rgba(15, 23, 42, 0.14));\n}\n\n/* Portaled above club switcher / home cards — must beat page stacking. */\n.header-role-menu--portal {\n    position: fixed;\n    top: auto;\n    right: auto;\n    z-index: 12050;\n}\n\n.header-role-menu__legend {\n    margin: 0 0 6px;\n    padding: 4px 8px;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: var(--text-secondary, var(--brand-text-secondary, #838383));\n}\n\n.header-role-menu__item {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 10px;\n    border: none;\n    border-radius: 10px;\n    background: transparent;\n    color: var(--text-color, #202226);\n    font: inherit;\n    font-size: 14px;\n    font-weight: 600;\n    text-align: left;\n    cursor: pointer;\n}\n\n.header-role-menu__item:hover {\n    background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08);\n}\n\n.header-role-menu__item.is-selected {\n    background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.14);\n    color: var(--brand-primary, #0877BC);\n}\n\n.dark-mode .header-role-menu__item.is-selected {\n    color: var(--brand-primary-light, #7dd3fc);\n}\n\n.header-role-menu__icon {\n    width: 28px;\n    height: 28px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: inherit;\n}\n\n@media (max-width: 768px) {\n    .header {\n        align-items: flex-start;\n    }\n\n    /* Notifications can stack above the brand icons; keep role + club on one row. */\n    .header-trailing {\n        flex-direction: column;\n        align-items: flex-end;\n        gap: 8px;\n    }\n\n    .header-brand-stack {\n        flex-direction: row;\n        align-items: center;\n        gap: 7px;\n    }\n}\n\n@media (max-width: 400px) {\n    .clublogo,\n    .header-role-btn {\n        width: 48px;\n        height: 48px;\n        max-width: 48px;\n        max-height: 48px;\n    }\n}\n\n/* Modern squircle button with glassmorphism and springy animations */\n.notification-btn {\n    background: rgba(255, 255, 255, 0.72);\n    backdrop-filter: blur(8px);\n    -webkit-backdrop-filter: blur(8px);\n    border-radius: 12px; /* Cohesive squircle */\n    width: 40px;\n    height: 40px;\n    border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08);\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03);\n    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n    position: relative;\n    padding: 0;\n    box-sizing: border-box;\n    text-decoration: none;\n}\n\n.notification-btn img {\n    width: 22px;\n    height: 22px;\n    object-fit: contain;\n    transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.notification-btn:hover {\n    background: var(--brand-surface, #fff);\n    transform: translateY(-2px);\n    border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.25);\n    box-shadow: 0 6px 16px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12), 0 2px 4px rgba(0, 0, 0, 0.04);\n}\n\n.notification-btn:hover img {\n    transform: scale(1.1);\n}\n\n.notification-btn:active {\n    transform: translateY(0) scale(0.95);\n    transition: all 0.1s ease;\n}\n\n/* Glowing Pulsating iOS-style red notification badge */\n.notification-badge {\n    position: absolute;\n    top: 7px;\n    right: 7px;\n    width: 8px;\n    height: 8px;\n    background-color: #ff3b30;\n    border-radius: 50%;\n    border: 2px solid var(--brand-surface, #fff);\n    box-shadow: 0 0 8px rgba(255, 59, 48, 0.6);\n    animation: badge-pulse 2s infinite;\n}\n\n@keyframes badge-pulse {\n    0% {\n        transform: scale(0.95);\n        box-shadow: 0 0 0 0 rgba(255, 59, 48, 0.7);\n    }\n    50% {\n        transform: scale(1.05);\n        box-shadow: 0 0 0 6px rgba(255, 59, 48, 0);\n    }\n    100% {\n        transform: scale(0.95);\n        box-shadow: 0 0 0 0 rgba(255, 59, 48, 0);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
